/**
 * Virtual Live directive
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 25.02.2016-15:11
 */

lmApp
  .controller('VirtualPlaylistController', ['$scope', '$templateCache', '$compile', '$q', 'AssetService', 'ManageAssetsWindow', 'ModalWindowService',
    function ($scope, $templateCache, $compile, $q, AssetService, ManageAssetsWindow, ModalWindowService) {

      $scope.playlistData = {
        isApproxDuration: false,
        totalDuration: ''
      };

      var _parseDuration = function (duration) {

        var hours = parseInt(duration / 3600, 10);
        var minutes = parseInt(duration / 60 % 60, 10);
        var seconds = parseInt(duration - (hours * 3600 + minutes * 60), 10);

        if (hours < 10) {
          hours = '0' + hours;
        }
        if (minutes < 10) {
          minutes = '0' + minutes;
        }
        if (seconds < 10) {
          seconds = '0' + seconds;
        }

        return hours + ':' + minutes + ':' + seconds;
      };

      $scope.parsePlaylist = function () {
        if (!$scope.playlist) return;

        $scope.playlist.forEach(function (group) {
          if (!group._PrivateData) group._PrivateData = {};
          group._PrivateData.isOver = false;

          if (group.type === 'multiple') {
            group._PrivateData.isMultipleOpen = !!group._PrivateData.isMultipleOpen;
            group._PrivateData.isApproxDuration = false;
            group._PrivateData.totalDuration = $scope.getGroupDuration(group);
          }

          group.items.forEach(function (item) {
            if (!item._PrivateData) item._PrivateData = {};

            item._PrivateData.isOver = false;
            item.real_duration = parseInt(item.real_duration, 10);
            if (!item.real_duration) {
              item._PrivateData.isApproxDuration = true;
            } else {
              item._PrivateData.isApproxDuration = false;
            }

            item._PrivateData.duration = _parseDuration(item.real_duration || item.duration || 0);
          });
        });
      };

      $scope.getGroupDuration = function (group) {

        return _parseDuration(_.reduce(group.items, function (memo, item) {
          if (_.isNumber(item.real_duration) && item.real_duration) {
            memo += item.real_duration;
          } else if (_.isNumber(item.duration) && item.duration) {
            memo += item.duration;

            group._PrivateData.isApproxDuration = true;
          }

          return memo;
        }, 0));
      };

      $scope.getPlaylistDuration = function (playlist) {

        return _parseDuration(_.reduce(playlist, function (memo, group) {

            return memo + _.reduce(group.items, function (memo, item) {
              if (_.isNumber(item.real_duration) && item.real_duration) {
                memo += item.real_duration;
              } else if (_.isNumber(item.duration) && item.duration) {
                memo += item.duration;

                $scope.playlistData.isApproxDuration = true;
              }

              return memo;
            }, 0);
          }, 0));
      };

      $scope.toggleMultiplePlaylist = function (item) {
        item._PrivateData.isMultipleOpen = !item._PrivateData.isMultipleOpen;
      };

      $scope.changeCollectionPriority = function (playlist, index, direction) {
        var t;
        switch (direction) {
          case 'up':
            if (index > 0) {
              t = playlist[index];
              playlist[index] = playlist[index - 1];
              playlist[index - 1] = t;
            }

            break;

          case 'down':
            if (index < playlist.length - 1) {
              t = playlist[index];
              playlist[index] = playlist[index + 1];
              playlist[index + 1] = t;
            }

            break;
        }
      };

      $scope.changeAssetPriority = function (items, index, direction) {
        var t;
        switch (direction) {
          case 'up':
            if (index > 0) {
              t = items[index];
              items[index] = items[index - 1];
              items[index - 1] = t;
            }

            break;

          case 'down':
            if (index < items.length - 1) {
              t = items[index];
              items[index] = items[index + 1];
              items[index + 1] = t;
            }

            break;
        }
      };

      $scope.deleteAssetFromCollection = function (playlist, index) {
        if (playlist[index]) playlist = playlist.splice(index, 1);
      };

      $scope.deleteCollectionFromPlaylist = function (playlist, index) {
        if (playlist[index]) playlist = playlist.splice(index, 1);
      };

      $scope.multipleGroupManage = function (item) {
        if ($scope.loading) return;

        if (!item) {
          item = {
            name: '',
            description: '',
            poster: '',
            items: [],
            type: 'multiple',
            isNew: true
          };
        }

        $scope.innerScope = $scope.$new();

        $scope.innerScope.item = item;

        $scope._createInner_ = $templateCache.get('edit-playlist-multiple.html');
        $scope._createInner_ = $compile($scope._createInner_)($scope.innerScope);

        ModalWindowService.Open({
          content: $scope._createInner_,
          isFixed: true,
          actions: [
            {
              title: item.isNew ? 'Add' : 'Save',
              color: 'green',
              fn: function () {
                if ($scope.innerScope.item.isNew) {
                  $scope.playlist.push($scope.innerScope.item)
                }
              }
            },
            {
              title: 'Cancel',
              color: 'red'
            }
          ],
          keyboard: true
        });

        $scope._createInner_.on('$destroy', function () {
          $scope.innerScope.$destroy();
        });
      };

      $scope.addSingleAsset = function () {
        ManageAssetsWindow.OpenManageAssetsWindow({
          manageAssetsFn: function (asset, toThis) {
            if ($scope.loading) return;

            if (asset.id) {

              $scope.playlist.push({
                type: 'single',
                items: [{
                  id: asset.id,
                  title: asset.title,
                  duration: asset.duration,
                  hls_deployment_status: _.get(_.find(asset.resources, {type: 'stream', stream_type: 'hls'}), 'is_deployed', false)
                }]
              });
            }

            return $q.when(true);
          },
          type: 'single',
          title: 'single asset in Playlist',
          view: 'vod',
          filter: {
            packages: true
          }
        });
      };

      $scope.addAssetToMultiplePlaylist = function (item) {
        if ($scope.loading) return;

        ManageAssetsWindow.OpenManageAssetsWindow({
          manageAssetsFn: function (toAdd, toRemove, toThis) {
            if ($scope.loading) return;

            item.items = _.chain(item.items)
              .difference(_.map(toRemove, function (asset) {
                return {
                  id: asset.id,
                  title: asset.title,
                  duration: asset.duration,
                  real_duration: 0,
                  hls_deployment_status: _.get(_.find(asset.resources, {type: 'stream', stream_type: 'hls'}), 'is_deployed', false)
                };
              }))
              .concat(_.map(toAdd, function (asset) {
                return {
                  id: asset.id,
                  title: asset.title,
                  duration: asset.duration,
                  real_duration: 0,
                  hls_deployment_status: _.get(_.find(asset.resources, {type: 'stream', stream_type: 'hls'}), 'is_deployed', false)
                };
              }))
              .value();

            $scope.parsePlaylist();

            return $q.when(true);
          },
          title: 'assets in Multiple Playlist',
          view: 'vod',
          currentCollection: [],
          filter: {
            packages: true
          }
        })
      };

      $scope.parsePlaylist();

      $scope.playlistWatcher = $scope.$watchCollection('playlist', function (newValue, oldValue) {
        if (_.size(newValue)) {
          $scope.parsePlaylist();
          $scope.playlistData.totalDuration = $scope.getPlaylistDuration(newValue);
        }
      });

      $scope.$on('$destroy', function () {
        $scope.playlistWatcher();
      });
    }
  ])
;

lmApp
  .directive('lmVirtualPlaylist', [function () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        playlist: '=',
        loading: '=',
        start: '='
      },
      controller: 'VirtualPlaylistController',
      link: function (scope, element, attrs) {

      },
      templateUrl: 'lm-virtual-playlist/lm-virtual-playlist.tpl.html'
    }
  }]);
